// The user object shape shared across UserContext, localStorage, and
// every place an auth response gets turned into one - App.js's initial
// hydration and session refresh, Login's password and social handlers,
// Signup's social handler (the plain email/password signup path
// already spreads the full response instead, so it doesn't need this).
// One place to add a field instead of four - the exact duplication
// that let `id` silently go missing from this shape in production for
// a while. is_team_admin is included even though nothing reads it yet
// today - CatalogContainer.jsx already defensively checks for it.
const buildUser = (data, isAuthenticated) => ({
  isAuthenticated,
  id: data.id,
  email: data.email,
  first_name: data.first_name,
  team: data.team,
  is_team_leader: data.is_team_leader,
  is_team_admin: data.is_team_admin,
  is_staff: data.is_staff,
  // False only while the address is unconfirmed (components/EmailConfirmationBanner.jsx);
  // undefined (an older cached user) is treated as confirmed.
  email_verified: data.email_verified,
  // Newest first-run guide version this person has been shown (server-side,
  // User.tour_seen_version); see utils/tour.js.
  tour_seen_version: data.tour_seen_version,
  // Every team this user belongs to, not just the active one (`team`,
  // above) - powers the team switcher. Falls back to [] for any
  // response shape that predates this field (e.g. a stale cached
  // localStorage value from before this shipped).
  teams: data.teams || [],
});

const loggedOutUser = () => buildUser({}, false);

export { buildUser, loggedOutUser };
